import { useStore } from "effector-react";

import SiteStore, {
    SiteStoreState,
    extractContentField,
    updateSiteStore,
    track,
    processForm,
} from "reliance-private-sitebuilder-common/dist/stores/SiteStore";

import {
    getPhone,
    classNames,
    renderHTML,
} from "reliance-private-sitebuilder-common/dist/util/common-utilities";

import { CheckCircleIcon } from "@heroicons/react/solid";

import Scroller from "reliance-private-sitebuilder-common/dist/components/Scroller";

export default function Home() {
    const site_store = useStore(SiteStore);
    const doSubmit = () => {
        updateSiteStore({
            state: SiteStoreState.POSTING,
        });
    };
    return (
        <>
            <div className={classNames("rounded-xl")}>
                <div
                    className={classNames(
                        !site_store.site.showFirm ? "hidden" : "",
                        "w-full text-center",
                        "xs:hidden",
                        extractContentField(
                            site_store,
                            "ADVERTISING_HEADER_SMALL",
                        ).css ?? "",
                    )}
                >
                    <div
                        className={
                            extractContentField(
                                site_store,
                                "PAID_ATTORNEY_ADVERTISING",
                            ).css ?? ""
                        }
                    >
                        {renderHTML(
                            extractContentField(
                                site_store,
                                "PAID_ATTORNEY_ADVERTISING",
                            ).value
                                ? extractContentField(
                                      site_store,
                                      "PAID_ATTORNEY_ADVERTISING",
                                  ).value +
                                      " " +
                                      site_store.site.firm?.name
                                : "",
                        )}
                    </div>
                </div>
                <div
                    className={classNames(
                        "w-full p-2 grid grid-cols-5 bg-color-MAIN_HEADER",
                        "xs:rounded-tl-md xs:rounded-tr-md",
                        "sm:rounded-tl-xl sm:rounded-tr-xl",
                    )}
                >
                    <div className={classNames("col-span-3")}>
                        <img
                            className={
                                extractContentField(site_store, "LOGO").css ??
                                ""
                            }
                            alt="logo"
                            src={`${site_store.strippedUri}/media/${extractContentField(site_store, "LOGO").value}`}
                        />
                    </div>
                    <div
                        className={classNames(
                            "col-span-2 grid items-center justify-items-center xs:justify-end",
                        )}
                    >
                        <button
                            className={classNames(
                                extractContentField(site_store, "TOP_PHONE")
                                    .css ?? "",
                            )}
                        >
                            <a
                                className={classNames("underline")}
                                href={`tel:${getPhone(site_store)}`}
                                onClick={() =>
                                    track({
                                        action: "click",
                                        what: "link",
                                        label: "yes",
                                        category: "phone",
                                    })
                                }
                            >
                                {getPhone(site_store)}
                            </a>
                        </button>
                    </div>
                </div>
                <div
                    className={classNames(
                        "w-full bg-color-MAIN_BACKGROUND pt-8 grid justify-items-center",
                        "md:pb-5",
                    )}
                >
                    <div
                        className={
                            extractContentField(site_store, "TOP_BANNER_1")
                                .css ?? ""
                        }
                    >
                        {renderHTML(
                            extractContentField(site_store, "TOP_BANNER_1")
                                .value ?? "",
                        )}
                    </div>
                    <div
                        className={
                            extractContentField(site_store, "TOP_BANNER_2")
                                .css ?? ""
                        }
                    >
                        {renderHTML(
                            extractContentField(site_store, "TOP_BANNER_2")
                                .value ?? "",
                        )}
                    </div>
                </div>
                <div
                    className={classNames(
                        "w-full justify-center bg-color-CAROUSEL_STATIONARY h-16",
                    )}
                >
                    <Scroller
                        items={(
                            extractContentField(site_store, "CAROUSEL_LIST")
                                .value ?? ""
                        )
                            .split("\n")
                            .filter((e) => e && e !== "")}
                        n={classNames(
                            "w-full h-16 flex flex-col justify-center items-center",
                            extractContentField(site_store, "CAROUSEL_LIST")
                                .css ?? "",
                        )}
                    />
                </div>
                <div
                    className={classNames(
                        "w-full bg-color-MAIN_BACKGROUND grid justify-items-center",
                        "md:pt-3",
                    )}
                >
                    <div
                        className={classNames(
                            "mx-auto",
                            extractContentField(site_store, "ARROW_TOP_TEXT")
                                .css ?? "",
                        )}
                    >
                        {renderHTML(
                            extractContentField(site_store, "ARROW_TOP_TEXT")
                                .value ?? "",
                        )}
                    </div>
                </div>
                <div
                    className={classNames(
                        "w-full bg-color-MAIN_BACKGROUND p-4 bg-clip-down",
                    )}
                ></div>
                <div
                    className={classNames(
                        "w-full grid justify-center pt-6 pb-6",
                    )}
                >
                    <form
                        onSubmit={(e) => {
                            doSubmit();
                            e.preventDefault();
                        }}
                    >
                        <div
                            className={classNames(
                                "w-full text-center justify-center",
                            )}
                        >
                            <input
                                className={classNames(
                                    "w-11/12 justify-items-center p-3 py-4 text-size-2xl rounded-md col-span-4 mb-2 bg-gray-100 mb-4",
                                )}
                                placeholder="First name"
                                autoComplete="given-name"
                                type="text"
                                required={true}
                                name="first_name"
                                value={site_store.formAnswers?.first_name ?? ""}
                                onChange={(e) =>
                                    processForm({
                                        fieldName: e.target.name!,
                                        fieldValue: e.target.value!,
                                    })
                                }
                            />
                            <input
                                className={classNames(
                                    "w-11/12 justify-items-center p-3 py-4 text-size-2xl rounded-md col-span-4 mb-2 bg-gray-100 mb-4",
                                )}
                                placeholder="Last name"
                                autoComplete="family-name"
                                type="text"
                                required={true}
                                name="last_name"
                                value={site_store.formAnswers?.last_name ?? ""}
                                onChange={(e) =>
                                    processForm({
                                        fieldName: e.target.name!,
                                        fieldValue: e.target.value!,
                                    })
                                }
                            />
                            <input
                                className={classNames(
                                    "w-11/12 justify-items-center p-3 py-4 text-size-2xl rounded-md col-span-4 mb-2 bg-gray-100 mb-4",
                                )}
                                placeholder="Email address"
                                autoComplete="email"
                                type="email"
                                required={true}
                                name="email"
                                value={site_store.formAnswers?.email ?? ""}
                                onChange={(e) =>
                                    processForm({
                                        fieldName: e.target.name!,
                                        fieldValue: e.target.value!,
                                    })
                                }
                            />
                            <input
                                className={classNames(
                                    "w-11/12 justify-items-center p-3 py-4 text-size-2xl rounded-md col-span-4 mb-2 bg-gray-100 mb-4",
                                )}
                                placeholder="Phone number"
                                autoComplete="tel"
                                type="tel"
                                required={true}
                                name="phone"
                                pattern="^(1\s*[\-\/\.]?)?(\((\d{3})\)|(\d{3}))\s*[\-\/\.]?\s*(\d{3})\s*[\-\/\.]?\s*(\d{4})\s*(([xX]|[eE][xX][tT])\.?\s*(\d+))*$"
                                value={site_store.formAnswers?.phone ?? ""}
                                onChange={(e) =>
                                    processForm({
                                        fieldName: e.target.name!,
                                        fieldValue: e.target.value!,
                                    })
                                }
                            />
                        </div>
                        <div className={classNames("w-full text-center pt-2")}>
                            <button
                                onClick={() =>
                                    track({
                                        action: "click",
                                        what: "button",
                                        label: "yes",
                                        category: "start",
                                    })
                                }
                                className={classNames(
                                    extractContentField(
                                        site_store,
                                        "CTA_BUTTON",
                                    ).css ?? "",
                                )}
                            >
                                {renderHTML(
                                    extractContentField(
                                        site_store,
                                        "CTA_BUTTON",
                                    ).value ?? "",
                                )}
                            </button>
                        </div>
                    </form>
                    <div
                        className={classNames(
                            "w-full justify-center pt-4 pb-8 clearfix",
                            "xs:text-center",
                        )}
                    >
                        <p
                            className={classNames(
                                "w-11/12 text-sm mx-auto color-QUIZ_NOTICE_TEXT",
                            )}
                        >
                            {site_store.site.firm?.formSubmitTerms &&
                            site_store.site.firm?.formSubmitTerms.trim() !==
                                "" ? (
                                renderHTML(
                                    site_store.site.firm?.formSubmitTerms,
                                )
                            ) : (
                                <>
                                    By submitting this form, you are agreeing to
                                    allow Reliance Litigation LLC to contact you
                                    at the phone number you supplied, even if
                                    it's on a national or state Do-Not-Call
                                    List. Calls/texts may employ automated
                                    dialing technology and
                                    prerecorded/artificial voice messages and
                                    emails. You are also confirming that you
                                    understand that your consent is not a
                                    condition of any purchase or obligation, and
                                    that this submission does not form an
                                    attorney/client relationship.
                                </>
                            )}
                        </p>
                    </div>
                </div>
                <div
                    className={classNames(
                        "w-full bg-color-MAIN_BACKGROUND p-4 bg-clip-up",
                    )}
                ></div>
                <div
                    className={classNames(
                        "w-full bg-color-MAIN_BACKGROUND grid justify-items-center",
                    )}
                >
                    <div
                        className={classNames(
                            "mx-auto text-center",
                            extractContentField(site_store, "ARROW_BOTTOM_TEXT")
                                .css ?? "",
                        )}
                    >
                        {renderHTML(
                            extractContentField(site_store, "ARROW_BOTTOM_TEXT")
                                .value ?? "",
                        )}
                    </div>
                    <div
                        className={classNames(
                            "mx-auto",
                            extractContentField(site_store, "COMPENSATION_LIST")
                                .css ?? "",
                        )}
                    >
                        <ul className={classNames("grid grid-cols-2 py-4")}>
                            {(
                                extractContentField(
                                    site_store,
                                    "COMPENSATION_LIST",
                                ).value ?? ""
                            )
                                .split("\n")
                                .filter((e) => e && e !== "")
                                .map((i, idx) => (
                                    <li
                                        key={idx}
                                        className={classNames(
                                            "col-span-2",
                                            "md:col-span-1 px-4",
                                        )}
                                    >
                                        <CheckCircleIcon
                                            className={classNames(
                                                "float-left h-6 align-center mt-1 pr-2",
                                            )}
                                        />
                                        <span className={classNames("")}>
                                            {i}
                                        </span>
                                    </li>
                                ))}
                        </ul>
                    </div>
                </div>
                <div className={classNames("w-full grid justify-center pb-6")}>
                    {renderHTML(
                        extractContentField(site_store, "MAIN_CONTENT").value ??
                            "",
                    )}
                </div>
            </div>
        </>
    );
}
